import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import { LOCALES, DEFAULT_LOCALE, SERVICE_NUMBER } from '../../../const/i18n';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
export var state = function state() {
  return {
    locales: LOCALES,
    currentLocale: DEFAULT_LOCALE,
    serviceNumber: SERVICE_NUMBER
  };
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};